import { render, staticRenderFns } from "./WhyChooseCard.vue?vue&type=template&id=62298c74&scoped=true"
import script from "./WhyChooseCard.vue?vue&type=script&lang=js"
export * from "./WhyChooseCard.vue?vue&type=script&lang=js"
import style0 from "./WhyChooseCard.vue?vue&type=style&index=0&id=62298c74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62298c74",
  null
  
)

export default component.exports